import { createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'src/utils/axiosConfig';

export const fectchHelpers = createAsyncThunk('general/helpers', async (_, { rejectWithValue }) => {
  try {
    const result = await Axios.get('/utilities/helpers');
    return result.data.data;
  } catch (error) {
    if (error.response) {
      return rejectWithValue(error.response.data);
    } if (error.request) {
      return rejectWithValue(error.request);
    }
    return rejectWithValue(error.message);
  }
});
